import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'
import {initReactI18next} from 'react-i18next'

// import {writable} from 'svelte/store'

// export const initI18n = (defaultLocale?: string | undefined) => {

// }

const loadResource = (language: string, namespace: string) =>
  import(`./locales/${language}/${namespace}.json`)

// 语言检测顺序：URL参数 -> localStorage -> 默认日文
const detectionOrder = ['querystring', 'localStorage']

// 导出 i18n 初始化 Promise，确保资源加载完成
export const i18nInitPromise = i18next
  .use(resourcesToBackend(loadResource))
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    detection: {
      order: detectionOrder,
      caches: ['localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'locales',
    },
    fallbackLng: {
      'zh-CN': ['zh'],
      'ja-JP': ['ja'],
      default: ['ja'],
    },
    ns: 'translation',
    returnEmptyString: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false, // not needed for svelte as it escapes by default
    },
  })
// const i18n = createI18nStore(i18next)
// const isLoadingStore = createIsLoadingStore(i18next)

export const getLanguages = async () => {
  const languages = (await import(`./locales/languages.json`)).default
  return languages
}
// export default i18n
// export const isLoading = isLoadingStore

export default i18next
